import React, { useState } from 'react';
import { Container, CardHeader, CardContent } from './styles'
import PropTypes from 'prop-types';
import arrowUp from 'components/Icon/png/Icon_ArrowUp.png';
import arrowDown from 'components/Icon/png/Icon_ArrowDown.png';

const propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.object,
}

const FormContainer = (props) => {
    const [collapse, setCollapse] = useState(false);

    return <Container>
        <CardHeader>
            {props.title}
            <label onClick={() => setCollapse(!collapse)}>
                <img src={ collapse ? arrowDown : arrowUp} width={15} height={10} />
            </label>

        </CardHeader>
        <CardContent isCollapse={collapse} >
            {props.children}
        </CardContent>
    </Container>

}

FormContainer.propTypes = propTypes;

export default FormContainer;